module.exports = __webpack_public_path__ + "media/images/logos/hi_bob-e4438c9b319263f835f52de71ff761d9.png";